import {
  CheckBoxItem,
  Dictionary,
  FilterMappingProps,
} from '../../CommonModel';

interface BaseFilterProps {
  farmCheckBoxList: CheckBoxItem[];
  setFarmCheckBoxList: (list: CheckBoxItem[]) => void;
  customerCheckBoxList: CheckBoxItem[];
  setCustomerCheckBoxList: (list: CheckBoxItem[]) => void;
  tagCheckBoxList: CheckBoxItem[];
  setTagCheckBoxList: (list: CheckBoxItem[]) => void;
}

export const useBaseFilter = ({
  farmCheckBoxList,
  setFarmCheckBoxList,
  customerCheckBoxList,
  setCustomerCheckBoxList,
  tagCheckBoxList,
  setTagCheckBoxList,
}: BaseFilterProps) => {
  const basefilters: Dictionary<FilterMappingProps> = {
    farm: {
      checkboxList: farmCheckBoxList,
      setCheckBoxList: setFarmCheckBoxList,
    },
    customer: {
      checkboxList: customerCheckBoxList,
      setCheckBoxList: setCustomerCheckBoxList,
    },
    tags: {
      checkboxList: tagCheckBoxList,
      setCheckBoxList: setTagCheckBoxList,
    },
  };
  return basefilters;
};
